var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    transform: "matrix(1 0 0 -1 0 49)",
    fill: "#D2F1F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9433 13.3694L12.9086 11.4743V37.522L25.9433 35.6252V13.3694Z",
    fill: "#246FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.441 13.3696L17.408 9.98772V39.0073L30.441 35.6254V13.3696Z",
    fill: "#2CA6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8383 13.3697L22.8053 8.68853V40.3066L35.8383 35.6255V13.3697Z",
    fill: "#48DDFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9194,
    height: 31.6129,
    fill: "white",
    transform: "matrix(1 0 0 -1 12.9086 40.3066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profile-picture.65d71dfb3b9ec10fb9ab8335cf200089.svg";
export { ForwardRef as ReactComponent };